import { render, staticRenderFns } from "./AddEditRole.vue?vue&type=template&id=bc8ba1da"
import script from "./AddEditRole.vue?vue&type=script&lang=js"
export * from "./AddEditRole.vue?vue&type=script&lang=js"
import style0 from "./AddEditRole.vue?vue&type=style&index=0&id=bc8ba1da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports